module.exports = __webpack_public_path__ + "static/media/google-play.df6c67ea.png";